import { render } from "./Historical.vue?vue&type=template&id=ca431b8e&scoped=true"
import script from "./Historical.vue?vue&type=script&lang=js"
export * from "./Historical.vue?vue&type=script&lang=js"

import "./Historical.vue?vue&type=style&index=0&id=ca431b8e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca431b8e"]])

export default __exports__